import { forwardRef } from 'react';

import DesktopReference from './desktop-reference';

type ReferenceFilterProps = {
  border?: boolean;
  sideBorder?: boolean;
  mainProps?: any;
};

const ReferenceFilter = forwardRef(
  ({ border, mainProps, sideBorder }: ReferenceFilterProps, ref) => {
    return (
      <DesktopReference
        ref={ref}
        border={border}
        mainProps={mainProps}
        sideBorder={sideBorder}
      />
    );
  }
);

ReferenceFilter.displayName = 'ReferenceFilter';

export default ReferenceFilter;
